import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Avatar,
  Button,
  CssBaseline,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Container } from "@mui/system";
import { MdLockOutline } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";
import CopyRight from "../../Components/CopyRight/CopyRight";
import { RiEyeFill, RiEyeOffFill } from "react-icons/ri";
import { Link } from "react-router-dom";

const AddNewPassword = () => {
  const { id, token } = useParams();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  let navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password) {
      toast.error("Parolni kiriting", {
        autoClose: 500,
        theme: "colored",
      });
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND}/api/password/forgot-password/${id}/${token}`,
        { newPassword: password }
      );
      if (data.msg.name === "TokenExpiredError") {
        toast.error(
          "Link vaqti tugatilgan. Yangi link orqali qaytadan urinib ko'ring",
          {
            autoClose: 500,
            theme: "colored",
          }
        );
      } else {
        toast.success(data.msg, { autoClose: 500, theme: "colored" });
        navigate("/login");
      }
    } catch (error) {
      toast.error(error.response.data.msg, {
        autoClose: 500,
        theme: "colored",
      });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "#1976d2" }}>
          <MdLockOutline />
        </Avatar>
        <Typography component="h1" variant="h5">
          Parolni tiklash
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Yangi parol kiritish"
            value={password}
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="password"
            type={showPassword ? "text" : "password"}
            id="password"
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  onClick={handleClickShowPassword}
                  sx={{ cursor: "pointer" }}
                >
                  {showPassword ? <RiEyeFill /> : <RiEyeOffFill />}
                </InputAdornment>
              ),
            }}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Saqlash
          </Button>
          <Link to="/login" variant="body2" style={{ color: "#1976d2" }}>
            Bosh sahifa
          </Link>
        </Box>
      </Box>
      <CopyRight sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
};

export default AddNewPassword;
